import {
  getBreadcrumbCategoryTextById,
} from "@/utils/normalizers/product";
import { getFullUrl } from "../htmlUtils";

export const getDevicesListBreadcrumbsProps = ({ id, query, segment, breadcrumbText }) => {
  const devicesUrl = getFullUrl(`/moviles/`, query);

  const breadcrumbsProps = {
    breadcrumbs: {
      title: getBreadcrumbCategoryTextById(id, breadcrumbText),
      "title-theme": "default",
      breadCrumbs: {
        Inicio: "/",
        ...(segment === 'au' ? { 'Autónomos': '/autonomos' } : {}),
        ...(id !== 'moviles' ? { "Móviles y electrónica": devicesUrl } : {})
      },
      textProps: {
        kind: "h",
        level: 1,
      },
      url: `/${id}`,
    },
    pills: null,
  };
  return breadcrumbsProps;
}

export const getDeviceBreadCrumProps = ({ id, aliasUrl, title, query, segment, breadcrumbText }) => {
  const devicesUrl = getFullUrl(`/moviles/`, query);
  const currentDeviceUrl = getFullUrl(`/${id}/`, query);

  const breadcrumbsProps = {
    breadcrumbs: {
      title,
      "title-theme": "default",
      textProps: {
        kind: "h",
        level: 1,
      },
      breadCrumbs: {
        Inicio: "/",
        ...(segment === 'au' ? { 'Autónomos': '/autonomos' } : {}),
        "Móviles y electrónica": devicesUrl,
        [getBreadcrumbCategoryTextById(id, breadcrumbText)]: currentDeviceUrl,
      },
      url: `/${id}/${aliasUrl}`,
    },
    pills: null,
  };

  return breadcrumbsProps;
}